// extracted by mini-css-extract-plugin
export default {"recos":"L2-z","productCardOverride":"M2-z","rowHasBadge":"N2-z"};